import React from "react";
import "./LanguageSelection.scss";
import "./CustomSelect.scss";
import UkFlag from "../../assets/icons/ukFlag.svg";
import ItFlag from "../../assets/icons/itFlag.svg";
import EsFlag from "../../assets/icons/esFlag.svg";
import { connect } from "react-redux";

const languages = [
  { code: "en", name: "ENG", flag: UkFlag },
  { code: "it", name: "ITA", flag: ItFlag },
  { code: "es", name: "ESP", flag: EsFlag },
];

const LanguageSelection = (props) => {
  const language = localStorage.getItem("lan") || props.language || "en";
  return (
    <div className="flag-container">
      {/* <div
        className={!lan.includes("en") ? "flag" : "flag active"}
        onClick={() => props.selectLanguage("en")}
      >
        <EsFlag />
        ENG
      </div>
      <div
        className={!lan.includes("it") ? "flag" : "flag active"}
        onClick={() => props.selectLanguage("it-it")}
      >
        <ItFlag />
        ITA
      </div> */}
      <CustomSelect
        defaultValue={
          languages.find((lan) => language.includes(lan.code)) || languages[0]
        }
        optionsList={languages}
        selectLanguage={props.selectLanguage}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  language: state.language.language,
});

export default connect(mapStateToProps)(LanguageSelection);
class CustomSelect extends React.Component {
  constructor(props) {
    super(props);

    // @defaultSelectText => Show default text in select
    // @showOptionList => Show / Hide List options
    // @optionsList => List of options
    this.state = {
      defaultSelectText: "",
      showOptionList: false,
      optionsList: [],
    };
  }

  componentDidMount() {
    // Add Event Listner to handle the click that happens outside
    // the Custom Select Container
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({
      defaultValue: this.props.defaultValue,
    });
  }

  componentWillUnmount() {
    // Remove the event listner on component unmounting
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  // This method handles the click that happens outside the
  // select text and list area
  handleClickOutside = (e) => {
    if (
      !e.target.classList.contains("custom-select-option") &&
      !e.target.classList.contains("selected-text")
    ) {
      this.setState({
        showOptionList: false,
      });
    }
  };

  // This method handles the display of option list
  handleListDisplay = () => {
    this.setState((prevState) => {
      return {
        showOptionList: !prevState.showOptionList,
      };
    });
  };

  // This method handles the setting of name in select text area
  // and list display on selection
  handleOptionClick = (e) => {
    this.props.selectLanguage(e.target.getAttribute("data-code"));
    this.setState({
      defaultValue: {
        name: e.target.getAttribute("data-name"),
        flag: e.target.getAttribute("data-flag"),
      },
      showOptionList: false,
    });
  };

  render() {
    const { optionsList } = this.props;
    const { showOptionList, defaultValue } = this.state;
    return (
      <div className="custom-select-container">
        <div
          className={showOptionList ? "selected-text active" : "selected-text"}
          onClick={this.handleListDisplay}
        >
          <img src={defaultValue?.flag} alt="flag" />
          {defaultValue?.name}
        </div>
        {showOptionList && (
          <ul className="select-options">
            {optionsList.map((option) => {
              return (
                <li
                  className="custom-select-option"
                  data-name={option.name}
                  data-flag={option.flag}
                  data-code={option.code}
                  key={option.code}
                  onClick={this.handleOptionClick}
                >
                  <img src={option.flag} alt="flag" />
                  {option.name}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }
}
